import React from 'react'

export default function Error() {

    return (
        <h3 className="medium-header">Ei saatavilla!</h3>
    )
}
